import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchNormalIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.6719 21.9629C6.15968 21.9629 1.67188 17.3629 1.67188 11.7129C1.67188 6.06289 6.15968 1.46289 11.6719 1.46289C17.1841 1.46289 21.6719 6.06289 21.6719 11.7129C21.6719 17.3629 17.1841 21.9629 11.6719 21.9629ZM11.6719 2.96289C6.95968 2.96289 3.13529 6.89289 3.13529 11.7129C3.13529 16.5329 6.95968 20.4629 11.6719 20.4629C16.3841 20.4629 20.2085 16.5329 20.2085 11.7129C20.2085 6.89289 16.3841 2.96289 11.6719 2.96289Z",
		fill: "#B6B6B6"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21.9149 22.9633C21.7295 22.9633 21.5441 22.8933 21.3978 22.7433L19.4466 20.7433C19.1636 20.4533 19.1636 19.9733 19.4466 19.6833C19.7295 19.3933 20.1978 19.3933 20.4807 19.6833L22.4319 21.6833C22.7149 21.9733 22.7149 22.4533 22.4319 22.7433C22.2856 22.8933 22.1002 22.9633 21.9149 22.9633Z",
		fill: "#B6B6B6"
	})]
});
export default SvgSearchNormalIcon;
